import { render } from "./AddColisPage.vue?vue&type=template&id=fb45e94a&ts=true"
import script from "./AddColisPage.vue?vue&type=script&lang=ts"
export * from "./AddColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__